import { environment, environmentUS } from 'src/environments';

export type RegionKey = 'central-us' | 'west-eu' | 'eu' | string;

/** Read the current region (runtime, no caching) */
export function getRegion(): RegionKey {
  // Keep it simple: always read fresh so changes in sessionStorage/localStorage take effect immediately.
  const value =
    JSON.parse(sessionStorage.getItem('bhm-dashboard:region') || '{}')?.d ||
    JSON.parse(localStorage.getItem('bhm-dashboard:region') || '{}')?.d ||
    'eu';

  return value;
}

/** Pick the environment object for a given region */
export function pickEnv(region: RegionKey) {
  return region === 'central-us' ? environmentUS : environment;
}

/** Convenience: get the current environment for the active region */
export function getCurrentEnv() {
  return pickEnv(getRegion());
}
